import { Base64 } from 'js-base64';
var BASE64_REGEX = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// trip.tripCSATText is stored base64-encoded; forms work with the decoded text.
// Legacy rows may hold plain text, which is returned as is instead of throwing.
// The shape check alone is not enough: short words built from the base64
// alphabet ("late", "test") match it and decode to mojibake without throwing,
// so only trust a decode that re-encodes back to the stored value.
export var decodeCsatText = function (value) {
    if (!value || value === 'null') {
        return '';
    }
    if (!BASE64_REGEX.test(value)) {
        return value;
    }
    try {
        var decoded = Base64.decode(value);
        return Base64.encode(decoded) === value ? decoded : value;
    }
    catch (err) {
        return value;
    }
};
export var encodeCsatText = function (value) {
    if (!(value === null || value === void 0 ? void 0 : value.trim().length)) {
        return null;
    }
    return Base64.encode(value);
};
//# sourceMappingURL=csatText.js.map